let refreshFn: (() => Promise<void>) | null = null

export const setAuthRefreshFn = (fn: (() => Promise<void>) | null) => {
  refreshFn = fn
}

export const tryRefreshToken = (): Promise<void> => {
  if (!refreshFn) {
    return Promise.reject(new Error('No auth refresh function registered'))
  }
  return refreshFn()
}
